// extracted by mini-css-extract-plugin
module.exports = {"radio_button":"Radio_radio_button__TKCCU","fake_radiobutton":"Radio_fake_radiobutton__82upH","label":"Radio_label__OZ8Iu"};